module.exports = __webpack_public_path__ + "img/title_2.8b815d5a.png";